/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ClientPromotionRewardDto { 
    kind?: ClientPromotionRewardDto.KindEnum;
    points?: number;
    couponName?: string;
    couponImage?: string;
    percentage?: number;
}
export namespace ClientPromotionRewardDto {
    export type KindEnum = 'POINTS' | 'COUPON' | 'CASHBACK';
    export const KindEnum = {
        Points: 'POINTS' as KindEnum,
        Coupon: 'COUPON' as KindEnum,
        Cashback: 'CASHBACK' as KindEnum
    };
}


